import { z } from 'zod'

export const createCategorySchema = z.object({
  name: z.string().trim().min(1, { message: 'カテゴリ名を入力してください' }),
  parentId: z.string().min(1, { message: '親カテゴリが未指定です' }),
  ownerId: z.string().nullable().optional(),
})

export type CreateCategoryInput = z.infer<typeof createCategorySchema>
